import { defineMessages } from '../define';

/** Экран одного конверта. */
export const pagesEnvelope = defineMessages({
  ru: {
    'envelopePage.fallbackName': 'Конверт',
    'envelopePage.edit': 'Изменить конверт',
    'envelopePage.missingTitle': 'Конверта нет',
    'envelopePage.missingDesc': (p: { period: string }) => `В периоде «${p.period}» такого конверта нет.`,
    'envelopePage.addTo': (p: { name: string }) => `Трата в «${p.name}»`,
    'envelopePage.txs': 'Траты',
    'envelopePage.emptyTitle': 'Пусто',
    'envelopePage.emptyDesc': (p: { period: string }) => `За ${p.period} трат в конверте нет`,
    'envelopePage.noNote': 'Без заметки',
    'envelopePage.spent': 'Потрачено',
    'envelopePage.over': 'Перерасход',
    'envelopePage.left': 'Осталось',
    'envelopePage.spentOf': (p: { spent: string; limit: string; pct: number }) => `потрачено ${p.spent} из ${p.limit} · ${p.pct}%`,
    'envelopePage.noLimit': 'без лимита',
    'envelopePage.carried': (p: { sum: string }) => `перенос ${p.sum}`,
  },
  en: {
    'envelopePage.fallbackName': 'Envelope',
    'envelopePage.edit': 'Edit envelope',
    'envelopePage.missingTitle': 'No envelope',
    'envelopePage.missingDesc': (p: { period: string }) => `There is no such envelope in "${p.period}".`,
    'envelopePage.addTo': (p: { name: string }) => `Expense in "${p.name}"`,
    'envelopePage.txs': 'Expenses',
    'envelopePage.emptyTitle': 'Empty',
    'envelopePage.emptyDesc': (p: { period: string }) => `No expenses in this envelope for ${p.period}`,
    'envelopePage.noNote': 'No note',
    'envelopePage.spent': 'Spent',
    'envelopePage.over': 'Overspent',
    'envelopePage.left': 'Left',
    'envelopePage.spentOf': (p: { spent: string; limit: string; pct: number }) => `spent ${p.spent} of ${p.limit} · ${p.pct}%`,
    'envelopePage.noLimit': 'no limit',
    'envelopePage.carried': (p: { sum: string }) => `rolled over ${p.sum}`,
  },
  be: {
    'envelopePage.fallbackName': 'Канверт',
    'envelopePage.edit': 'Змяніць канверт',
    'envelopePage.missingTitle': 'Канверта няма',
    'envelopePage.missingDesc': (p: { period: string }) => `У перыядзе «${p.period}» такога канверта няма.`,
    'envelopePage.addTo': (p: { name: string }) => `Трата ў «${p.name}»`,
    'envelopePage.txs': 'Траты',
    'envelopePage.emptyTitle': 'Пуста',
    'envelopePage.emptyDesc': (p: { period: string }) => `За ${p.period} трат у канверце няма`,
    'envelopePage.noNote': 'Без нататкі',
    'envelopePage.spent': 'Выдаткавана',
    'envelopePage.over': 'Перарасход',
    'envelopePage.left': 'Засталося',
    'envelopePage.spentOf': (p: { spent: string; limit: string; pct: number }) => `выдаткавана ${p.spent} з ${p.limit} · ${p.pct}%`,
    'envelopePage.noLimit': 'без ліміту',
    'envelopePage.carried': (p: { sum: string }) => `перанос ${p.sum}`,
  },
});
